import { useEffect, useState } from "react";

type IconProps = {
  className?: string;
  fill?: string;
};

const NotebookIcon = ({ className, fill }: IconProps) => {
  const [_class, setClass] = useState(className);

  useEffect(() => {
    let classStr = className || "";
    if (!classStr.includes("w-")) {
      classStr += " w-5";
    }
    if (!classStr.includes("h-")) {
      classStr += " h-5";
    }

    setClass(classStr);
  }, [className]);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 16 16"
      // strokeWidth="0"
      stroke={fill}
      className={_class}
    >
      <path
        opacity="0.2"
        d="M5 13.5H3C2.86739 13.5 2.74021 13.4473 2.64645 13.3536C2.55268 13.2598 2.5 13.1326 2.5 13V3C2.5 2.86739 2.55268 2.74021 2.64645 2.64645C2.74021 2.55268 2.86739 2.5 3 2.5H5V13.5Z"
        fill="#2E2E2E"
      />
      <path
        d="M7 7H11"
        stroke="#2E2E2E"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7 9H11"
        stroke="#2E2E2E"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13 2.5H3C2.72386 2.5 2.5 2.72386 2.5 3V13C2.5 13.2761 2.72386 13.5 3 13.5H13C13.2761 13.5 13.5 13.2761 13.5 13V3C13.5 2.72386 13.2761 2.5 13 2.5Z"
        stroke="#2E2E2E"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5 2.5V13.5"
        stroke="#2E2E2E"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default NotebookIcon;
